import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("spinner-overlay", () => {
    it("should render correctly in closed state", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-spinner-overlay></ux-spinner-overlay>`);
        const el = await page.find("ux-spinner-overlay");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render correctly in opened state", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-spinner-overlay opened></ux-spinner-overlay>`);
        await new Promise((resolve) => setTimeout(resolve, 800));
        const el = await page.find("ux-spinner-overlay");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-spinner-overlay opened></ux-spinner-overlay>`);
    });
});
